import { useState } from "react";

/* ═══ Loading state helper for Firestore collections ═══ */
export function useCollectionState(initial = []) {
  const [data, setData] = useState(initial);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  return { data, setData, loading, setLoading, error, setError };
}
